
 // dropdown progress bar toggle
  function toggleDetails() {
    const dropdown = document.getElementById('points-details');
    const arrowIcon = document.getElementById('arrow-icon');

    dropdown.style.display = dropdown.style.display === 'flex' ? 'none' : 'flex';
    arrowIcon.classList.toggle('rotated');

    dropdown.querySelectorAll('.progress').forEach(bar => {
   //   bar.style.width = dropdown.style.display === 'block' ? bar.dataset.width : '0';
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.progress').forEach(bar => {
      const parentDropdown = bar.closest('#points-details');
      if (!parentDropdown || parentDropdown.style.display !== 'none') {
      //  bar.style.width = bar.dataset.width;
      }
    });
  });

// announcementslider js
  function initCartAnnouncementSlider() {
    var slider = document.querySelector('.cart-announcement-slider');
    if (slider && typeof Flickity !== 'undefined' && !slider.classList.contains('flickity-enabled')) {
      new Flickity(slider, {
        autoPlay: 3000,
        wrapAround: true,
        pauseAutoPlayOnHover: false,
        prevNextButtons: false,
        pageDots: true
      });
    }
  }

  initCartAnnouncementSlider();

  const observer = new MutationObserver(() => {
    initCartAnnouncementSlider();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

// cart product flickity js
  function initializeFlickity() {
    var flickityElement = document.querySelector('.cart-collection-slider .flickity-slider');
    console.log('call');
    if (flickityElement && flickityElement.flickity) {
        flickityElement.flickity('destroy');
    }

    // Initialize Flickity again
    var flickity = new Flickity(flickityElement, {
        cellAlign: 'left',
        contain: true,
        groupCells: true,
        imagesLoaded: true,
        lazyLoad: true,
        pageDots: false
    });
}
initializeFlickity();